module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRx-Program-Video.51f1ad67.jpg";